;(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(exports)
    : typeof define === 'function' && define.amd
    ? define(['exports'], factory)
    : factory((global.nrkSerumImagecropUtils = {}))
})(this, function(exports) {
  'use strict'

  var isPolopolyIdRegex = /^[1-9]{1,2}\.\d+$/

  function isPolopolyId(id) {
    if (!id) {
      return false
    }
    return isPolopolyIdRegex.test(id)
  }

  // prettier-ignore
  var widths = [100, 120, 150, 174, 200, 206, 225, 244, 250, 252, 300, 320, 350, 400, 450, 452, 460, 462, 500, 600, 650, 665, 682, 700, 734, 768, 900, 974, 1200, 1280, 1360, 1450, 1550, 1600, 1700, 1800, 1920, 2000, 2100, 2200, 2300, 2400];

  // prettier-ignore
  var ratios = ['1:1', '11', '16:9', '169', '16:3', '163', '3:4', '34'];

  // prettier-ignore
  var qualities = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0];

  var _baseUrl = 'https://static.nrk.no/dh/module/klima-spesial/images/'

  function createUrl(_ref) {
    var id = _ref.id,
      ratio = _ref.ratio,
      width = _ref.width,
      quality = _ref.quality

    var url = '' + _baseUrl + id
    var queryString = createQueryString({ ratio: ratio, width: width, quality: quality })
    if (queryString) {
      url += '' + queryString
    }
    return url + '.jpg'
  }

  function createQueryString(_ref2) {
    var ratio = _ref2.ratio,
      width = _ref2.width,
      quality = _ref2.quality

    if (!ratio && !width) {
      return quality ? 'quality=' + quality : ''
    }
    var ratioPart = ratio ? 'f' + ratio.replace(':', '') : ''
    var widthPart = width ? 'w' + width : ''
    var qualityPart = quality ? '&quality=' + quality : ''
    return '-' + ratioPart + widthPart
  }

  function getClosestNumber(goal, targets) {
    if (!isValidGoal(goal)) {
      throw new Error(
        '\n      getClosestNumber(goal, targets): passing a goal of ' + goal + '\n      is not supported. Pass a number'
      )
    }
    if (!isValidTargets(targets)) {
      throw new Error(
        '\n      getClosestNumber(goal, targets): targets ' +
          targets.toString() +
          ' is invald.\n      Pass an array of numbers'
      )
    }
    if (!targets.length) {
      // eslint-disable-next-line no-undefined
      return undefined
    }
    return targets.reduce(function(prev, curr) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev
    })
  }

  function isValidGoal(goal) {
    return typeof goal === 'number'
  }

  function isValidTargets(targets) {
    if (!targets) {
      return false
    }
    var isValid = true
    for (var i = 0; i < targets.length; i++) {
      if (typeof targets[i] !== 'number') {
        isValid = false
        break
      }
    }
    // return targets.some((target) => {
    //   return (typeof target !== 'number')
    // })
    return isValid
  }

  function isValidRatio(ratio, supportedRatios) {
    if (!Array.isArray(supportedRatios)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error(
        "isValidRatio(ratio, supportedRatios): supportedRatios '" +
          supportedRatios +
          "' is not supported. Pass an array of supported ratios"
      )
    }
    if (!ratio) {
      return false
    }
    return supportedRatios.includes(ratio)
  }

  function isValidQuality(quality, supportedQualities) {
    if (!Array.isArray(supportedQualities)) {
      // eslint-disable-next-line no-useless-escape
      throw new Error(
        "isValidQuality(quality, supportedQualities): supportedQualities '" +
          supportedQualities +
          "' is not supported. Pass an array of supported qualities"
      )
    }
    if (!quality) {
      return false
    }
    return supportedQualities.includes(quality)
  }

  function createImageUrl(options) {
    var polopolyId = options.id,
      width = options.width,
      ratio = options.ratio,
      quality = options.quality

    if (!isPolopolyId(polopolyId)) {
      throw new Error('createSerumImageUrl(): invalid polopolyId. Got ' + polopolyId)
    }

    var args = {
      id: polopolyId,
      ratio: null,
      quality: 0.8,
      width: 0

      // If a ratio is provided, ensure that it is valid
    }
    if (hasOption(ratio)) {
      if (!isValidRatio(ratio, ratios)) {
        throw new Error(
          '\n      createSerumImageUrl(): ratio ' +
            ratio +
            ' is not supported.\n      Supported ratios are ' +
            ratios.toString()
        )
      }
      args.ratio = ratio
    }

    // If a quality is provided, ensure that it is valid
    if (hasOption(quality)) {
      if (!isValidQuality(quality, qualities)) {
        throw new Error(
          '\n      createSerumImageUrl(): quality ' +
            quality +
            ' is not supported.\n      Supported qualities are ' +
            qualities.toString()
        )
      }
      args.quality = quality
    }

    // If a width is provided, ensure that is is a positive integer
    if (hasOption(width)) {
      if (!isNumber(width) || width <= 0) {
        var errorMessage = 'createSerumImageUrl(): width must be a positive integer, got ' + width
        throw new Error(errorMessage)
      }
      var isSupportedWidth = widths.includes(width)
      var closestWidth = getClosestNumber(width, widths)
      if (typeof closestWidth !== 'undefined' && closestWidth) {
        args.width = isSupportedWidth ? width : closestWidth
      }
    }

    return createUrl(args)
  }

  function hasOption(option) {
    return typeof option !== 'undefined' && option
  }

  function isNumber(number) {
    return Number.isInteger(number)
  }

  exports.createImageUrl = createImageUrl
  exports.ratios = ratios
  exports.widths = widths
  exports.qualities = qualities
  exports.isPolopolyId = isPolopolyId

  Object.defineProperty(exports, '__esModule', { value: true })
})
